import Text from "../molecules/content/Text";
import PhoneNumberForm from "../organisms/forms/phoneNumber/PhoneNumberForm";
import Content from "../templates/wrapper/Content";
import { formattedPhone, getCountryCode } from "../../helpers/utils";
import { useContext } from "react";
import { AuthContext } from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useToast } from "../../hooks/useToast";
import SignOutButton from "../molecules/buttons/SignOutButton";

const AddPhoneNumber = () => {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const navigate = useNavigate();
  let countryCode = getCountryCode();
  const authContext = useContext(AuthContext);

  const handleConfirmAddForm = async (values) => {
    try {
      const phone_number = formattedPhone(values.phone_number, countryCode);
      const attr = { Name: "phone_number", Value: phone_number };
      await authContext.setAttribute(attr);
      await authContext.getSessionInfo()
      navigate("/verify/code");
    } catch (error) {
      showToast("error", String(error?.message));
    }
  };

  const signOutClicked = async () => {
    try {
      await authContext.signOut();
    } catch (error) {
      showToast("error", String(error?.message));
    }
  };

  return (
    <Content showRemoveOnDesktop onClose={signOutClicked}>
      <div className="flex flex-col items-center">
        <Text variant="h3" className="text-vestelColor">
          {t("addPhoneNumber.title")}
        </Text>
      </div>
      <div className="pt-5">
        <PhoneNumberForm
          onSubmit={handleConfirmAddForm}
          description={t("addPhoneNumber.description")}
          label={t("addPhoneNumber.title")}
        />
      </div>
      <div className="text-center py-12">
        <SignOutButton />
      </div>
    </Content>
  );
};

export default AddPhoneNumber;
